<template>
  <Content id="users">
    <div slot="search">
      <Form :label-width="40" :model="search" id="searchForm">
        <Row>
          <Col><FormItem label="姓名"><el-input v-model="search.name" :maxlength="50" :clearable="true"/></FormItem></Col>
          <Col>
            <FormItem label="来源">
              <Select v-model="search.sources" style="width: 100%;" :clearable="true">
                <Option v-for="item in sourcesList" :value="item.value" v-bind:key="item.value" style="width: 100%;">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="是否已建档" :label-width="90">
              <Select v-model="search.archives" style="width: 100%;" :clearable="true">
                <Option v-for="item in archivesList" :value="item.value" v-bind:key="item.value" style="width: 100%;">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="状态">
              <Select v-model="search.status" style="width: 100%;" :clearable="true">
                <Option v-for="item in enums.status" :value="item.value" v-bind:key="item.value" style="width: 100%;">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <div style="display:flex;">
              &nbsp;&nbsp;<Button type="primary" @click="query">查询</Button>
            </div>
          </Col>
        </Row>
      </Form>

      <div slot="extra" style="margin-bottom: 5px; display: flex;width: 100%" >
        <Button size="small" style="margin-left: 5px;"  icon="md-add" @click="handleCreate" type="primary">新增</Button>
      </div>
    </div>

    <el-table :data="dataList" ref="singleTable" style="width: 100%;" :header-cell-style="{ background:'#f8f8f9',color:'#515a6e','text-align':'center'}"
              :row-class-name="tableRowClassName" @row-click="selectrow" highlight-current-row highlight-selection-row row-key="id" :max-height="tableHeight">

    <el-table-column fixed="left" align="center" prop="name" label="姓名" show-overflow-tooltip  min-width="100"/>
      <el-table-column fixed="left" align="center" prop="gender" label="性别" show-overflow-tooltip min-width="80">
        <template slot-scope="{row}">{{ row.gender === 1 ? '男' : row.gender === 2 ? '女' :  '' }}</template>
      </el-table-column>
      <el-table-column align="center" prop="birthday" label="出生日期" show-overflow-tooltip  min-width="95"/>
      <el-table-column align="center" prop="age" label="年龄" show-overflow-tooltip  min-width="80"/>
      <el-table-column align="center" prop="idCardType" label="证件类型" show-overflow-tooltip min-width="150">
        <template slot-scope="{row}">{{  enums.idCardTypes.filter(u => u.value === row.idCardType)[0].label }}</template>
      </el-table-column>
      <el-table-column align="center" prop="idCard" label="证件号码" show-overflow-tooltip  min-width="180"/>
      <el-table-column align="center" prop="phone" label="手机号码" show-overflow-tooltip  min-width="100"/>
      <el-table-column align="center" prop="telPhone" label="固定电话" show-overflow-tooltip  min-width="100"/>
      <el-table-column align="center" prop="nationsName" label="民族" show-overflow-tooltip  min-width="100"/>
      <el-table-column align="center" prop="archives" label="建档" show-overflow-tooltip min-width="80">
        <template slot-scope="{row}" v-if=" row.archives == 1 || row.archives == 2">
          <el-tag size="small" :type="row.archives == 1 ? 'danger' : 'primary'">{{ row.archives === 1 ? "未建档" : row.archives === 2 ? "已建档" : ""}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="sources" label="来源" show-overflow-tooltip min-width="80">
        <template slot-scope="{row}">
          {{  row.sources === 1 ? "小程序" : row.sources === 2 ? "pc系统" : row.sources === 3 ? "医生端小程序" : "" }}
        </template>
      </el-table-column>
      <el-table-column fixed="right" align="center" prop="status" label="状态"  min-width="100">
        <template slot-scope="{row}">
          <el-switch v-model="row.status" :active-value="1" :inactive-value="2" @change="handleEditStatus(row, null, row.status)"/>
        </template>
      </el-table-column>
      <el-table-column fixed="right" align="center" prop="operation" label="操作"  min-width="80">
        <template slot-scope="{row}">
          <el-button type="text" size="medium" @click="handleEdit(row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <Page :total="pageList.total" :current="pageList.currentPage" :page-size="pageList.pageSize"
          show-elevator show-sizer show-total @on-change="chagecurrent"
          :page-size-opts="[10, 30, 50, 100]"
          @on-page-size-change="chagepagesize" style="margin-top:10px;"/>

    <Modal v-model="editWindow" width="50%" :title="windowTitle" :styles="{'top':'60px'}" :mask-closable="false">
      <ResidentEdit ref="edit" :style="{'max-height':maxHeight, 'overflow-y':'auto'}" @on-submit="handleSubmit"/>
      <div slot="footer">
        <Button @click="editWindow = false">取消</Button>
        <Button type="primary" @click="submit">确认</Button>
      </div>
    </Modal>

  </Content>
</template>
<script>
import { _page, _updateStatus} from "@/services/resident/resident";
import ResidentEdit from "./ResidentEdit";
import {enums} from "@/services/enums";
export default {
  name: "Resident",
  components: {
    ResidentEdit
  },
  computed: {

  },
  data() {
    return {
      tableHeight: 0,
      currentRowIndex: null,
      search: {
        name:"",
        sources:"",
        archives:"",
        status:1
      },
      sourcesList:[
        {label: '小程序', value: 1},
        {label: 'pc系统', value: 2},
        {label: '医生端小程序', value: 3},
      ],
      archivesList:[
        {label: '未建档', value: 1},
        {label: '已建档', value: 2},
      ],
      enums:Object.assign({},enums),
      importWindow:false,
      editWindow:false,
      windowTitle:"新增居民",
      dataList: [],
      pageList: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
    };
  },
  created(){
    this.setDynamicHeight();
    window.addEventListener('resize', this.setDynamicHeight);
  },
  mounted() {
    if (this.$userSession.checkInstitutionId()) {
      this.handleDataList();
    }
  },
  methods: {
    setDynamicHeight() {
      const height = window.innerHeight || document.documentElement.clientHeight;
      this.tableHeight = `${height - 300}px`;
    },
    handleEditStatus(row, index, targetValue){
      if(row && row.id){
        return new Promise((resolve,reject) => {
          this.$confirm(`是否确定${targetValue === 1 ? "启用" : "停用"}${row.name}吗?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true,
            type: 'warning'
          }).then((result)=>{
            _updateStatus({id:row.id, status: targetValue}).then(res =>{
              if (res.errcode === 1) {
                this.handleDataList();
              }else {
                this.$message.error(res.errmsg);
                reject()
              }
            }).catch(() => {
              reject()
            });
          }).catch(function (e) {
            if (e === 'cancel' || e === 'close') {
              row.status = (targetValue === 1 ? 2 : 1);
            }
          })
        });
      }
    },
    query() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }

      this.pageList.currentPage = 1;
      this.handleDataList();
    },
    handleDataList() {
      _page({
        ...this.search,
        ...this.pageList
      }).then(res => {
        this.dataList = res.data.records;
        this.pageList.total = res.data.total;
      }).catch(() => {});
    },
    handleModal(windowTitle, row) {
      this.windowTitle = windowTitle;
      this.editWindow = true;
      this.$refs["edit"].handleModal(row);
    },
    handleCreate() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }
      this.handleModal("新增");
    },
    handleEdit(row) {
      this.handleModal("编辑", row);
    },
    submit(){
      this.$refs['edit'].handleSubmit();
    },
    handleSubmit(result) {
      if(!result){
        this.editWindow = result;
        this.handleDataList();
      }
    },
    tableRowClassName(row, rowIndex) {
      row.row.index = row.rowIndex;
      if (this.currentRowIndex === row.rowIndex) {
        return "select-row";
      }else{
        return "";
      }
    },
    selectrow(e, index, event){
      this.currentRowIndex = e.index;
    },
    chagecurrent(e) {
      this.pageList.currentPage = e
      this.handleDataList()
    },
    chagepagesize(e) {
      this.pageList.pageSize = e
      this.handleDataList()
    },
  }
};
</script>
<style lang="postcss" scoped>
/deep/ #searchForm .ivu-form-item {margin-bottom: 5px;vertical-align: top;zoom: 1;}
/deep/ .el-table .el-table__cell {padding: 11px 0;}

</style>
